import { client } from "api";
import { TimeEntry } from "models/TimeEntry";

export type FilterAllTimeEntriesPublicRequest = {
  searchQuery: string;
  fromDate: string | null; // ISO string
  toDate: string | null; // ISO string
  officeIds: number[] | null;
  departmentIds: number[] | null;
};

export type FilterAllTimeEntriesPublicResponse = TimeEntry[];

export const filterAllTimeEntriesPublic = (
  request: FilterAllTimeEntriesPublicRequest
): Promise<FilterAllTimeEntriesPublicResponse> =>
  client
    .post<FilterAllTimeEntriesPublicResponse>("/absence/filterPublic", request)
    .then((res) => res.data);
